import {
  CURRENT_ONBOARDING_VERSION,
  CURRENT_PRICING_PAGE_VERSION,
} from '@contentlab/types/onBoardingFlags';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';

function useOnboardingFlags() {
  const {dashboardUser, isFetching} = useDashboardUserQuery({});
  return {
    onboardingVersionCompleted: dashboardUser.latestScalerOnboardingViewed,
    pricingPageVersionSeen: dashboardUser.latestScalerPricingPageViewed,
    isFetching,
    hasCompletedCurrentOnboardingVersion:
      dashboardUser.latestScalerOnboardingViewed === CURRENT_ONBOARDING_VERSION,
    hasSeenCurrentPricingPageVersion:
      dashboardUser.latestScalerPricingPageViewed ===
      CURRENT_PRICING_PAGE_VERSION,
  };
}

export default useOnboardingFlags;
